import type { ReactNode } from 'react';

type Tone = 'info' | 'warning' | 'danger' | 'success';

const tones: Record<Tone, string> = {
  info: 'bg-accent-subtle text-accent-text',
  warning: 'bg-warning-subtle text-warning-text',
  danger: 'bg-danger-subtle text-danger-text',
  success: 'bg-success-subtle text-success-text',
};

interface AlertProps {
  tone?: Tone;
  title?: string;
  children: ReactNode;
  action?: ReactNode;
}

export function Alert({ tone = 'info', title, children, action }: AlertProps) {
  return (
    <div
      role={tone === 'danger' ? 'alert' : 'status'}
      className={`flex flex-col gap-2 rounded-md p-4 text-sm ${tones[tone]}`}
    >
      {title && <p className="font-semibold">{title}</p>}
      <div>{children}</div>
      {action}
    </div>
  );
}
